import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import FilterSection from '../../../filter-section/FilterSection';
import TopMessagesTable from './top-messages-table/TopMessagesTable';
import HighPerformingAudiences from '../high-performing-audiences/HighPerformingAudiences';
import HighPerformingVariables from '../high-performing-variables/HighPerformingVariables';
import HighPerformingMessages from '../high-performing-messages/HighPerformingMessages';
import MessageSelectDisclaimer from '../message-select-disclaimer/MessageSelectDisclaimer';
import safeSum from '../../../../../utils/safeSum';
import AudienceFilters from '../../../audience-filters/AudienceFilters';
import { useProject } from '../../../../../context/ProjectContext';

import scss from './TopMessages.module.scss';

function TopMessages() {
  const { id: projectId } = useParams();
  const [selectedMessage, setSelectedMessage] = useState(null);

  const { actions } = useProject();

  const messages = useSelector((state) => state.resonance.messages);

  const handleSelectMessage = (message) => {
    if (message.id && selectedMessage?.id !== message.id) {
      setSelectedMessage(message);
    } else {
      setSelectedMessage(null);
    }
  };

  const handleSelectTopMessage = () => {
    const sortedMessages = [...messages].sort((a, b) => getSortValue(b) - getSortValue(a));
    setSelectedMessage(sortedMessages[0]);
  };

  useEffect(() => {
    if (messages.length) {
      handleSelectTopMessage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages]);

  useEffect(() => {
    if (selectedMessage?.id) {
      actions('getSingleMessageCorrelations', { projectId, messageId: selectedMessage.id });
    }
  }, [selectedMessage?.id, projectId, actions]);

  return (
    <div className={scss.wrapper}>
      <FilterSection filters={AudienceFilters}>
        {({ appliedFilters }) => (
          <TopMessagesTable
            appliedFilters={appliedFilters}
            selectedMessage={selectedMessage}
            onMessageSelect={handleSelectMessage}
          />
        )}
      </FilterSection>
      {!selectedMessage ? <MessageSelectDisclaimer /> : null}

      {selectedMessage ? <HighPerformingAudiences selectedMessage={selectedMessage} /> : null}
      {selectedMessage ? <HighPerformingVariables selectedMessage={selectedMessage} /> : null}
      {selectedMessage ? <HighPerformingMessages selectedMessage={selectedMessage} /> : null}
    </div>
  );
}

export default TopMessages;

const getSortValue = (message) => safeSum(message.accurateR1Total, message.accurateR2Total);
